import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const TenantAuthContext = createContext(null);
const API_URL = process.env.REACT_APP_BACKEND_URL;

export const TenantAuthProvider = ({ children }) => {
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('tenant_token'));

  useEffect(() => {
    if (token) {
      fetchDashboard();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchDashboard = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/tenant-portal/dashboard`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTenant(res.data);
    } catch {
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const res = await axios.post(`${API_URL}/api/tenant-portal/login`, { email, password });
    const { access_token, tenant_name, tenant_id } = res.data;
    localStorage.setItem('tenant_token', access_token);
    setToken(access_token);
    setTenant({ tenant_name, tenant_id });
    return res.data;
  };

  // Used by the accept-invite flow: the recipient just set their password
  // and the backend already issued them a portal JWT. We sync it into both
  // localStorage and context state so the protected /tenant routes don't
  // see a stale (null) token and bounce them to the operator login.
  const acceptToken = (access_token) => {
    localStorage.setItem('tenant_token', access_token);
    setToken(access_token);
  };

  const logout = () => {
    localStorage.removeItem('tenant_token');
    setToken(null);
    setTenant(null);
  };

  return (
    <TenantAuthContext.Provider value={{ tenant, loading, login, acceptToken, logout, token }}>
      {children}
    </TenantAuthContext.Provider>
  );
};

export const useTenantAuth = () => {
  const context = useContext(TenantAuthContext);
  if (!context) throw new Error('useTenantAuth must be used within TenantAuthProvider');
  return context;
};
